import React from 'react';
import { LegalIssueOption } from './legal-issue-item';
import { LoiFormAnswerType, LoiFormAnswerTypeList } from './loi-form-answer-type.enum';

const usesFixedOptionList = (answerType: LoiFormAnswerType): boolean =>
    answerType === LoiFormAnswerType.PurchaseAgreementType ||
    answerType === LoiFormAnswerType.LeaseRateUponExtension;

export const getLoiAnswerSelectOptions = (
    answerType: LoiFormAnswerType,
    options?: LegalIssueOption[]
): LegalIssueOption[] => {
    if (!usesFixedOptionList(answerType)) {
        return options ?? [];
    }
    if ((options ?? []).length > 0) {
        return options ?? [];
    }
    const definition = LoiFormAnswerTypeList.find((d) => d.id === answerType);
    return definition?.options ?? [];
};

export const renderLoiAnswerReadonly = (
    value: string | null,
    answerType: LoiFormAnswerType,
    options?: LegalIssueOption[]
): React.ReactNode => {
    const resolvedValue = value ?? '';
    if (usesFixedOptionList(answerType)) {
        const selectedOption = getLoiAnswerSelectOptions(answerType, options).find(
            (o) => o.value === resolvedValue
        );
        return (
            <span className="loi-form-value-readonly">
                {selectedOption ? selectedOption.label : resolvedValue}
            </span>
        );
    }
    return <span className="loi-form-value-readonly">{resolvedValue}</span>;
};
